import { render, staticRenderFns } from "./dj-media-image-upload-drawer.vue?vue&type=template&id=6c333229&scoped=true&"
import script from "./dj-media-image-upload-drawer.vue?vue&type=script&lang=js&"
export * from "./dj-media-image-upload-drawer.vue?vue&type=script&lang=js&"
import style0 from "./dj-media-image-upload-drawer.vue?vue&type=style&index=0&id=6c333229&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c333229",
  null
  
)

export default component.exports